import React from 'react';
import { NumericFormat } from 'react-number-format';

const NumberInput = ({
  disabled = false,
  label,
  name,
  value,
  onChange,
  required = false,
  py = 'py-3',
  textSize = 'text-base',
  decimalScale = 8,
  fixedDecimalScale = false,
  allowNegative = false,
  placeholder,
  maxValue,
}) => {
  const handleValueChange = (values, sourceInfo) => {
    if (sourceInfo.source !== 'event') return;

    const { floatValue } = values;

    onChange({
      target: {
        name,
        value: floatValue ?? 0,
      },
    });
  };

  const isAllowed = (values) => {
    const { floatValue } = values;

    if (floatValue === undefined) return true;

    if (maxValue !== undefined && maxValue !== null) {
      return floatValue <= Number(maxValue);
    }

    return true;
  };

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={name} className="text-lg text-blueDarker font-normal">
          {label}
          {required && <span className="ml-1.5">*</span>}
        </label>
      )}

      <NumericFormat
        id={name}
        name={name}
        required={required}
        disabled={disabled}
        value={value}
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={decimalScale}
        fixedDecimalScale={fixedDecimalScale}
        allowNegative={allowNegative}
        placeholder={placeholder}
        isAllowed={isAllowed}
        onValueChange={handleValueChange}
        className={`w-full border border-bluePale rounded-xl px-3 ${py} ${textSize} placeholder-blueSteel`}
      />
    </div>
  );
};

export default NumberInput;
